export function assertIsDefined<T>(val: T, txt = ""): asserts val is NonNullable<T> {
  if (val === undefined || val === null) {
    const text = txt ? ` [${txt}]` : "";
    throw new Error(`Expected value to be defined, but received ${val}${text}`);
  }
}
